import React, { useEffect, useState } from 'react';
import { Button, Table, Accordion, Pagination, InputGroup } from 'react-bootstrap';
import { useTranslate } from 'react-polyglot';
import { useAuth } from '../../../Auth';
import { useAxios } from '../../../AxiosHandler';
import Field from '../Wizard/Field/Field';

import './PageTable.scss';

function PageTable(props) {
	const showLabels = props.options.showFields;
	const auth = useAuth();
	const axiosHandler = useAxios();
	const axios = axiosHandler.axios;
	const t = useTranslate();
	//let history = useHistory();

	const [isCheckedAll, setIsCheckedAll] = useState(false);
    const [checkedItems, setCheckedItems] = useState<Array<any>>([]);
	const [totalAmount, setTotalAmount] = useState(0);

	const [dropdownSelected, setDropdownSelected] = useState({value: "", label: t("pagetable.function_choosetext")});

	const [ data, setData ] = useState([ {} ]);
	const [ checkedAmount, setCheckedAmount] = useState(0);
	const [ currentPageNumber, setCurrentPage ] = useState(0);
	const [ pageData, setPageData ] = useState([ {} ]);
	const [ pageSize, setPageSize ] = useState(props.options != undefined && props.options.pageSize != undefined ? props.options.pageSize : 10);
	const [ selectedOption, setSelectedOption ] = useState(0);
	const [ dataUrl ] = useState(props.dataUrl);

    const [ searchValueArray, setSearchValueArray ] = useState(props.filters != undefined ? props.filters : props.options.showFields.map((label) => {
		return { field: label.field, type: "and", values: [''] };
	}));
    const [ selectedHeaderField, setSelectedHeaderField ] = useState(props.defaultSortField != undefined ? props.defaultSortField : "_id" ); 
    const [ sortDirection, setSortDirection ] = useState(props.defaultSortDirection != undefined ? props.defaultSortDirection : "desc" );
    const [ loading, setLoading ] = useState(true);

	const showItemsRange = [ 3, 5, 10, 15, 25, 50, 100 ];

	// useEffect that triggers on selected -> 

	const handleCheckSingle = (event, checkedItem) => {
		//let checkedItem = event.target.id;
		let isChecked = event.target.checked;
		let tmpCheckedItems: any = checkedItems;
		if (isChecked) { // adding to list
			tmpCheckedItems.push(checkedItem);
			setCheckedAmount(tmpCheckedItems.length);
		} else {// removing from list
			tmpCheckedItems = tmpCheckedItems.filter(i => i["_id"] != checkedItem._id);
			setCheckedAmount(tmpCheckedItems.length);
			setIsCheckedAll(false);
		}
	
		setCheckedItems(JSON.parse(JSON.stringify(tmpCheckedItems)));

		if (props.onSingleLineTick != undefined) {
            props.onSingleLineTick(tmpCheckedItems);
        }
	};

	function updateCheckedItems(){
		if(props.updateCheckedItems != undefined) {
			axios.single({
				method: 'post',
				url: props.updateCheckedItems,
				responseType: 'json',
				data: checkedItems.map(item => item._id),
				headers: { 'x-access-token': auth.user['token'] }
			})
			.then((res) => {
				setCheckedItems(res.data);
			});
		}
	}

	const handleCheckAll = () => {
		if (!isCheckedAll) {
			fetchDataBySelectAll(currentPageNumber, pageSize, selectedHeaderField, sortDirection, props.checkAllUrl);
		} else {
			setCheckedItems([]);
			setCheckedAmount(0);

		}
		setIsCheckedAll(!isCheckedAll);
	  };

    const setPageSizeChanged = (value) => {
        let newPageSize = parseInt(value);
        let newCurrentPageNumber = 0;
        setPageSize(value);
        setSelectedOption(value);
        fetchData(newCurrentPageNumber, newPageSize);
    };

    const handleSearch = (value,label) => {
        let searchValues = searchValueArray;
        let searchValue = searchValues.find(value => value["field"] == label);

        if (searchValue != undefined) {
            (searchValue["values"] as any)[0] = value;
        }
        setSearchValueArray(searchValues);  
        fetchData(currentPageNumber,pageSize);
		setCurrentPage(0);
		if(props.checkAllUrl != undefined ) {
			fetchTotalAmount(0, 10, "id", "asc", props.checkAllUrl);
		}
     };

     const handleSorting = (label) =>{
		let direction = sortDirection === "asc" ? "desc" : "asc";
		if (label != selectedHeaderField) {
			direction = "asc";
		}
        setSortDirection(direction);
        setSelectedHeaderField(label);
        fetchData(currentPageNumber, pageSize, label, direction);
     }
    
	function setPagination(pageData) {
		const { pagestotal } = pageData;
		const next = () => {
			let nextPage = Math.min(currentPageNumber + 1, pagestotal);
			setCurrentPage(nextPage);
			fetchData(nextPage, pageSize, selectedHeaderField, sortDirection);
		};

		const prev = () => {
			let prePage = currentPageNumber - 1;
			setCurrentPage(prePage);
			fetchData(prePage, pageSize, selectedHeaderField, sortDirection);
		};

		const first = () => {
			setCurrentPage(0);
			fetchData(0, pageSize, selectedHeaderField, sortDirection);
		};

		const last = () => {
			setCurrentPage(pagestotal - 1);
			fetchData(pagestotal - 1, pageSize, selectedHeaderField, sortDirection);
		};


		return (
			<div className="pagination">
				<Pagination>
					<Pagination.First onClick={first} disabled={currentPageNumber == 0} />
					<Pagination.Prev onClick={prev} disabled={currentPageNumber == 0} />
					<Pagination.Item active>{currentPageNumber + 1} / {pagestotal}</Pagination.Item>
					<Pagination.Next onClick={next} disabled={currentPageNumber + 1 == pagestotal} />
					<Pagination.Last onClick={last} disabled={currentPageNumber + 1 == pagestotal} />
				</Pagination>
				<select className='mdb-select md-form'
					onChange={e => setPageSizeChanged(e.target.value)}
					value={selectedOption}
				>
					{showItemsRange != undefined ? showItemsRange.map(size => {
						return (
							<option key={size} value={size}> {size} </option>
						)})
					: ""}
				</select>
			</div>
		);
	}

	async function fetchData(currentPageNumber = 0, pageSize = 10, label= "id" , direction = "asc", newUrl = dataUrl) {
		axios
			.single({
				method: 'post',
				url: newUrl,
				responseType: 'json',
				data: {
					...(props.data != undefined ? props.data : {}),
					pagenumber: currentPageNumber,
					pagesize: pageSize,
					sorting: { field: label, order: direction },
					exclusiveFilters: props.exclusiveFilters,
					filters: [
						...searchValueArray.filter((searchValue) => searchValue['values'].length != 0),
						...(props.permaFilters != undefined ? props.permaFilters : [])
					]
				},
				headers: { 'x-access-token': auth.user['token'] }
			})
			.then((res) => {
				setData(res != undefined ? res['data']['pagedata'] : []);
				setPageData(res != undefined ? res['data'] : []);
				setCurrentPage(currentPageNumber);
				setLoading(false);
			});
	}

	async function fetchDataBySelectAll(currentPageNumber = 0, pageSize = 10, label= "id" , direction = "asc", newUrl = dataUrl) {
		axios
			.single({
				method: 'post',
				url: newUrl,
				responseType: 'json',
				data: {
					...(props.data != undefined ? props.data : {}),
					pagenumber: currentPageNumber,
					pagesize: pageSize,
					sorting: { field: label, order: direction },
					exclusiveFilters: props.exclusiveFilters,
					filters: [
						...searchValueArray.filter((searchValue) => searchValue['values'].length != 0),
						...(props.permaFilters != undefined ? props.permaFilters : [])
					]
				},
				headers: { 'x-access-token': auth.user['token'] }
			})
			.then((res) => {

				let tmpCheckedItems: any = [];
				let totalAmount = res.data.pagedata.length;
				res.data.pagedata.forEach(item => {
					tmpCheckedItems.push({ ...item, isChecked: true});
				});
				setCheckedAmount(totalAmount);
				setCheckedItems(JSON.parse(JSON.stringify(tmpCheckedItems)));
				if (props.onSingleLineTick != undefined) {
					props.onSingleLineTick(tmpCheckedItems);
				}

				setLoading(false);
			});
	}

	async function fetchTotalAmount(currentPageNumber = 0, pageSize = 10, label= "id" , direction = "asc", allDataUrl){
		axios.single({
			method: "post",
			url: allDataUrl,
			responseType: "json",
			data: {
				...(props.data != undefined ? props.data : {}),
				pagenumber: currentPageNumber,
				pagesize: pageSize,
				sorting: { field: label, order: direction },
				exclusiveFilters: props.exclusiveFilters,
				filters: [
					...searchValueArray.filter((searchValue) => searchValue['values'].length != 0),
					...(props.permaFilters != undefined ? props.permaFilters : [])
				]
			},
			headers: {'x-access-token': auth.user["token"]}
		}) 
		.then((res) => {
			setTotalAmount(res.data.pagedata.length)
		 })
		 .catch(err => console.log(err));
	}

	useEffect(() => {

		fetchData(currentPageNumber, pageSize, selectedHeaderField, sortDirection, props.dataUrl);
		setSelectedOption(pageSize);
		if(props.checkAllUrl != undefined ) {
			fetchTotalAmount(0, 10, "id", "asc", props.checkAllUrl);
		}
		updateCheckedItems();
		
		//fetchDataBySelectAll(currentPageNumber, pageSize, selectedHeaderField, sortDirection, props.checkAllUrl);
    }, [
		props.dataUrl,
		props.updateTable,
		props.exclusiveFilters,
		props.permaFilters,
	]);

	return (
		<div className="pagetable">
			{loading ?
				<div>
					<p className="loadingtext">{props.loadingText != undefined ? props.loadingText : t("pagetable.loading")}</p>
				</div>
			: 
				<Accordion>
					<div>
						{props.hideFilter == undefined || props.hideFilter == true ? "" : 
							<Accordion.Toggle className="clickable filterbtn no-print" as={Button} eventKey="0">
								<i className="dripicons-search" />
							</Accordion.Toggle>
						}
						{ props.selectedFunctions != undefined && props.hideMultifunctions != true ? 
							<div className="actionselector no-print">
								<Field
									type="reactselect"
									value={dropdownSelected}
									onChange={value => {
										let selectedFunc = props.selectedFunctions.find(i => i.label == value.value);
										if (selectedFunc != undefined) {
											selectedFunc.func(checkedItems);
											setDropdownSelected({value: "", label: t("pagetable.function_choosetext")});
										}
									}}
									options={{
										choosetext: t("pagetable.function_choosetext"),
										choices: props.selectedFunctions!= undefined ? [{label: t("pagetable.function_choosetext"), value: ""}, ...props.selectedFunctions.map((option, key) => { return {label: option["label"], value: option["label"]}})] : ""
									}}
									disabled={checkedItems.length < 1}
								></Field>
							</div>
						: null}
						<Table striped hover={props.hover}>
							<thead>
								<tr>
									{ props.selectedFunctions != undefined ? 
										<th className="nohover checkall">{ props.allDataUrl != undefined ? checkedAmount + "/" + totalAmount : "" }
											<InputGroup className="mb-3 checkallbox">
												<InputGroup.Prepend>
													<InputGroup.Checkbox  id={"selectAll"} 
														onChange={handleCheckAll}
														onClick={(evt) => evt.stopPropagation() }
														checked={isCheckedAll}
													/>
												</InputGroup.Prepend>
											</InputGroup>
										</th>
									: null}
									{ props.dataBefore != undefined ?
										<th></th>
									: null}
									{showLabels != undefined ?
										showLabels.map((i, key) => <th key={key} onClick={() => {
											handleSorting(i.field);
										}}>{i.label} { i.field == selectedHeaderField ?
											sortDirection == "asc" ? 
												<i className="fa fa-sort-alpha-down"></i>
											:
												<i className="fa fa-sort-alpha-down-alt"></i>
										: ""}</th>)
									: <th />}
									{props.dataAfter != undefined ?
										<th></th>
									: null}
								</tr>
									<tr>
										{props.selectedFunctions != undefined ?                      
											<td className="headerfilter"></td>
										: null}
										{props.dataBefore != undefined && props.dataBefore.length > 0 ? (
											<td>
												<div></div>
											</td>   
											) : null
										}
										{ showLabels != undefined && searchValueArray.length > 0 ? (
											showLabels.map((i, key) => {
												return (
													<td key={key} className="headerfilter">
														<Accordion.Collapse eventKey="0">
															
															{i.noFilter == undefined ?
																(i.customFilters == undefined ?
																	<input
																		type="text"
																		id={i.label}
																		placeholder={t("pagetable.label_filter")}
																		onChange={(event) => handleSearch(event.target.value, i.field)}
																	/>
																:
																	<Field
																		type="select"
																		disabled={ i.disableFilter != undefined }
																		value={{value: searchValueArray.find(value => value["field"] == i.field).values[0]}}
																		onChange={ (val) => handleSearch(val.value, i.field) }
																		options={{
																			choosetext: i.choosetext == undefined ? t("pagetable.label_filter_change") : i.choosetext,
																			choices: i.customFilters
																		}}
																	></Field>
																) : <div></div>
															}
														</Accordion.Collapse>
													</td>
												);
											})
										) : <td></td>}
										{props.dataAfter != undefined ?                      
											<td className="headerfilter"></td>
										: null}
									</tr>
							</thead>
							<tbody>
								{data.map((dataLine, key) =>(  
									<tr className={
										props.hoverExempt != undefined ?
											props.hoverExempt(dataLine) == true ? 
												"nohover"
											: ""
										: ""
									} key={key} onClick={(evt) =>{ 
										evt.stopPropagation(); 
										evt.nativeEvent.stopImmediatePropagation(); 
										if (props.onLineClick != undefined) {
											props.onLineClick(dataLine);
										}
									}}>
										{ props.selectedFunctions != undefined ? 
										<td >
											<InputGroup className="mb-3" >
												<InputGroup.Prepend>
													<InputGroup.Checkbox
														onChange={(event) => handleCheckSingle(event, dataLine)}
														onClick={(evt) => evt.stopPropagation() }
														checked={checkedItems.find(i => i["_id"] == dataLine["_id"]) != undefined ? checkedItems.find(i => i["_id"] == dataLine["_id"]) : false}
													/>
												</InputGroup.Prepend>
											</InputGroup>
										</td>
										: null}

										{props.dataBefore != undefined ?
											<td>
												{props.dataBefore(dataLine)}
											</td>
										: null}
										
										{showLabels.map((label, labelkey) => (    
											<td
												key={labelkey}
												onMouseOver={(evt) => {
													if (label.maxLength != undefined && evt.currentTarget.scrollWidth != evt.currentTarget.clientWidth) {
														evt.currentTarget.classList.add("maxlengthhovering");
													}
												}}
												onMouseOut={(evt) => label.maxLength != undefined ? evt.currentTarget.classList.remove("maxlengthhovering") : null}
												style={label.maxLength != undefined ? {
													marginBottom: "0px",
													overflow: "hidden",
													textOverflow: "ellipsis",
													whiteSpace: "nowrap",
													maxWidth: label.maxLength + "px"
												} : {}}
											>
												{label.override == undefined ?
													(typeof dataLine[label.field] == "string") ? dataLine[label.field].split("\n").map((l, key) => 
														<p key={key} style={{
															marginBottom: "0px"
														}}>{l}</p>
													) : dataLine[label.field]
												: label.override(dataLine)}
											</td>
										))}

										{props.dataAfter != undefined ?
											<td>
												{props.dataAfter(dataLine)}
											</td>
										: null}
									</tr>))}
							</tbody>
						</Table>
					</div>
					{ props.hidePagination == undefined || props.hidePagination == true ? 
						"" : <div className="no-print"> {setPagination(pageData)} </div>
					}
				</Accordion>
			}
		</div>
	);
}

export default PageTable;
